import React from "react";
import "./ngofooter.css";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function NgoFooter() {
  return (
    <footer className="footer">

      <div className="container">

        <div className="row">

          {/* ABOUT */}
          <div className="col-md-4 col-12 footer-section">
            <h4>ORRBIIT Relief</h4>

            <p>
              Helping stray dogs with food, rescue and medical care.
              Every small donation can save a life.
            </p>
          </div>


          {/* QUICK LINKS */}
          <div className="col-md-4 col-12 footer-section">
            <h4>Quick Links</h4>

            <ul className="footer-links">
              <li>Home</li>
              <li>Mission</li>
              <li>Stories</li>
              <li>Gallery</li>
              <li>Contact</li>
            </ul>
          </div>


          {/* SOCIAL MEDIA */}
          <div className="col-md-4 col-12 footer-section">
            <h4>Connect With Us</h4>

            <div className="social-links">

              <a href="https://instagram.com/orrbiitrelief" target="_blank" rel="noreferrer">
                <i className="bi bi-instagram"></i> @orrbiitrelief
              </a>

              <a href="https://facebook.com/orrbiitrelief" target="_blank" rel="noreferrer">
                <i className="bi bi-facebook"></i> ORRBIIT Relief
              </a>

              <a href="https://twitter.com/orrbiitrelief" target="_blank" rel="noreferrer">
                <i className="bi bi-twitter-x"></i> @orrbiitrelief
              </a>

              <a href="https://youtube.com/@orrbiitrelief" target="_blank" rel="noreferrer">
                <i className="bi bi-youtube"></i> ORRBIIT Relief
              </a>

            </div>
          </div>

        </div>


        {/* COPYRIGHT */}
        <div className="footer-bottom">
          © {new Date().getFullYear()} ORRBIIT Relief
        </div>

      </div>

    </footer>
  );
}